var _path, _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0669 17.4971C25.4941 17.4971 25.0317 17.9683 25.0317 18.5522V20.8347C25.0317 21.415 24.6176 21.8898 24.1103 21.8898H2.99179C2.48453 21.8898 2.07044 21.415 2.07044 20.8347V3.1653C2.07044 2.58499 2.48453 2.1102 2.99179 2.1102H24.1103C24.6176 2.1102 25.0317 2.58499 25.0317 3.1653V5.44783C25.0317 6.03165 25.4941 6.50293 26.0669 6.50293C26.6397 6.50293 27.1021 6.03165 27.1021 5.44783V3.1653C27.1021 1.42087 25.7598 0 24.1103 0H2.99179C1.34234 0 0 1.42087 0 3.1653V20.8347C0 22.5791 1.34234 24 2.99179 24H24.1103C25.7598 24 27.1021 22.5791 27.1021 20.8347V18.5522C27.1021 17.9719 26.6397 17.4971 26.0669 17.4971Z",
    fill: "#666666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 15,
    height: 8,
    rx: 1,
    stroke: "#666666",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11.8333,
    r: 1,
    fill: "#666666",
    stroke: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.3638c1a31abad075b5d48abe918002c9.svg";
export { ForwardRef as ReactComponent };